import {
  detail,
  getShopZXInfoByShopId,
  shopGoodsNew,
  categoryList,
  shopIndex,
  getBoIdByShopId
} from "@/api/shop/shopDetails";

export default {
  namespaced: true,
  state: {
    list: []
  },
  actions: {
    async detail(context, params) {
      const data = await detail(params);
      return data;
    },
    async getShopZXInfoByShopId(context, params) {
      const data = await getShopZXInfoByShopId(params);
      return data;
    },
    async shopGoodsNew(context, params) {
      const data = await shopGoodsNew(params);
      return data;
    },
    async categoryList(context, params) {
      const data = await categoryList(params);
      return data;
    },
    async shopIndex(context, params) {
      const data = await shopIndex(params);
      return data;
    },
    async getBoIdByShopId(context, params) {
      const data = await getBoIdByShopId(params);
      return data;
    }
  }
};
